import { BaseFleetEntry } from "../../api/fleet"
import {
  isOffCoverAfterOnCover,
  isOffCoverAfterOnCoverError,
  isOffCoverDateWithinLast14Days,
  isOffCoverDateWithinLast14DaysError,
  isOffCoverWithinPolicyDates,
  isOffCoverWithinPolicyDatesError,
} from "./checks"
import { GeneratorProps } from "./types"

const validateOffCoverDate = (entry: Partial<BaseFleetEntry>, props: GeneratorProps) => {
  const { curentEntries, policyDuration, hasAdminAccess } = props
  if (isOffCoverDateWithinLast14Days(entry, curentEntries, policyDuration, hasAdminAccess) === false) {
    return isOffCoverDateWithinLast14DaysError
  }
  if (isOffCoverAfterOnCover(entry, curentEntries, policyDuration, hasAdminAccess) === false) {
    return isOffCoverAfterOnCoverError
  }
  if (isOffCoverWithinPolicyDates(entry, curentEntries, policyDuration, hasAdminAccess) === false) {
    return isOffCoverWithinPolicyDatesError
  }
  return undefined
}

export const generateValidateOffCoverDate = (props: GeneratorProps) => (entry: Partial<BaseFleetEntry>) =>
  validateOffCoverDate(entry, props)
